module.exports = __webpack_public_path__ + "static/media/KOA.f7b15574.png";